import { render, staticRenderFns } from "./VerificationEmailModal.vue?vue&type=template&id=5d60d544&scoped=true&"
import script from "./VerificationEmailModal.vue?vue&type=script&lang=js&"
export * from "./VerificationEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60d544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d60d544')) {
      api.createRecord('5d60d544', component.options)
    } else {
      api.reload('5d60d544', component.options)
    }
    module.hot.accept("./VerificationEmailModal.vue?vue&type=template&id=5d60d544&scoped=true&", function () {
      api.rerender('5d60d544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/VerificationEmailModal.vue"
export default component.exports